import { render, staticRenderFns } from "./TheLoading.vue?vue&type=template&id=bf81c3c6&"
import script from "./TheLoading.vue?vue&type=script&lang=js&"
export * from "./TheLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports